import { type ClientPerspective, QueryParams } from '@sanity/client'

import {
  PageMetadata,
  sanityFetch,
  sanityFetchPageMetadata,
} from '@/lib/apis/sanity'
import { fetchCmsTemplateData } from '@/lib/cms/template-data'
import { renderCmsStrings } from '@/lib/cms/templating'

export type CmsQuery = {
  query: string
  params?: QueryParams
  tags?: string[]
  perspective?: ClientPerspective
}

// The CMS content layer: fetches from Sanity and pipes every string in the
// result through Mustache templating with dynamic data (backend pricing and
// shared social-proof values).
// All CMS reads should go through this module rather than calling the Sanity
// client directly, so templated content behaves the same everywhere.
export async function cmsFetch<QueryResponse>(
  query: CmsQuery,
): Promise<QueryResponse> {
  const [result, templateData] = await Promise.all([
    sanityFetch<QueryResponse>(query),
    fetchCmsTemplateData(),
  ])

  return renderCmsStrings(result, templateData)
}

export async function cmsFetchPageMetadata(url: string): Promise<PageMetadata> {
  const [metadata, templateData] = await Promise.all([
    sanityFetchPageMetadata(url),
    fetchCmsTemplateData(),
  ])

  return renderCmsStrings(metadata, templateData)
}

export type {
  CmsTemplateData,
  PriceTemplateValue,
  PricingTemplateName,
} from '@/lib/cms/template-data'
export { fetchCmsTemplateData } from '@/lib/cms/template-data'
export { renderCmsStrings } from '@/lib/cms/templating'
